/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';

import Editor, { createEditorStateWithText } from 'draft-js-plugins-editor';

import createToolbarPlugin, { Separator } from 'draft-js-static-toolbar-plugin';
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton
} from 'draft-js-buttons';
import 'draft-js-static-toolbar-plugin/lib/plugin.css';
import '../scss/editorStyles.css';
import {
  ContentState,
  convertFromHTML,
  convertToRaw,
  EditorState
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener('click', this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map(
          (
            Button,
            i // eslint-disable-next-line
          ) => (
            <Button key={i} {...this.props} />
          )
        )}
      </div>
    );
  }
}

export class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
const plugins = [toolbarPlugin];

export default class CustomToolbarEditor extends Component {
  constructor(props) {
    var content, htmlContent;
    super(props);
    this.props = props;
    htmlContent = '';
    if (props.content) {
      htmlContent = props.content;
      const blocksFromHTML = convertFromHTML(htmlContent);
      content = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      this.state = {
        editorState: EditorState.createWithContent(content)
      };
    } else {
      content = '';
      this.state = {
        editorState: createEditorStateWithText(content)
      };
    }
  }

  onChange = editorState => {
    this.setState({
      editorState
    });
  };

  focus = () => {
    this.editor.focus();
  };

  getHTML() {
    const rawContentState = convertToRaw(
      this.state.editorState.getCurrentContent()
    );
    return draftToHtml(rawContentState);
  }

  editTemplate() {
    this.props.componentContext.componentParent.setTemplateMode(true);
  }

  render() {
    return (
      <div>
        <div className="editor" onClick={this.focus}>
          <Toolbar>
            {
              // may be use React.Fragment instead of div to improve perfomance after React 16
              externalProps => (
                <div style={{ position: 'relative' }}>
                  <BoldButton {...externalProps} />
                  <ItalicButton {...externalProps} />
                  <UnderlineButton {...externalProps} />
                  <Separator {...externalProps} />
                  <HeadlinesButton {...externalProps} />
                  <UnorderedListButton {...externalProps} />
                  <OrderedListButton {...externalProps} />
                  <BlockquoteButton {...externalProps} />
                  <CodeBlockButton {...externalProps} />
                  {!this.props.templateMode &&
                    this.props.templateId /* eslint-disable-next-line */ && (
                      <a
                        style={{
                          color: '#4c84ff',
                          cursor: 'pointer',
                          position: 'absolute',
                          right: '2rem',
                          lineHeight: 2
                        }}
                        onClick={this.editTemplate.bind(this)}
                      >
                        Edit email template
                      </a>
                    )}
                </div>
              )
            }
          </Toolbar>
          <Editor
            editorState={this.state.editorState}
            onChange={this.onChange}
            plugins={plugins}
            ref={element => {
              this.editor = element;
            }}
          />
        </div>
      </div>
    );
  }
}
